(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    const key = `chrome:announcement:${bar.dataset.announcementKey}`;
    const read = () => {
      try {
        return localStorage.getItem(key) === '1';
      } catch {
        return false;
      }
    };
    if (read()) bar.hidden = true;
    bar.querySelector('[data-announcement-close]')?.addEventListener('click', () => {
      bar.hidden = true;
      try {
        localStorage.setItem(key, '1');
      } catch {
        /* navigation privée : on ferme sans mémoriser */
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appointment"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-appointment]');
    if (!root) return;
    const form = root.querySelector('form');
    if (!form) return;
    const dateInput = root.querySelector('[data-appointment-date]');
    const slotSelect = root.querySelector('[data-appointment-slot]');
    const dateError = root.querySelector('[data-appointment-date-error]');
    if (!dateInput || !slotSelect) return;
    const texts = root.dataset;
    const duration = Number(texts.duration) || 60;
    const step = Number(texts.step) || 30;
    const noticeHours = Number(texts.noticeHours) || 0;

    const pad = (n) => String(n).padStart(2, '0');
    const toMinutes = (hhmm) => {
      const [h, m] = hhmm.trim().split(':').map(Number);
      return h * 60 + (m || 0);
    };
    const toHHMM = (minutes) => `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
    const isoDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    // Présélection par l'URL : ?boutique=2
    const wanted = new URLSearchParams(window.location.search).get('boutique');
    if (wanted) {
      const radio = root.querySelector(`[data-store-index="${CSS.escape(wanted)}"]`);
      if (radio) radio.checked = true;
    }

    const today = new Date();
    dateInput.min = isoDate(today);
    const max = new Date(today);
    max.setDate(max.getDate() + 60);
    dateInput.max = isoDate(max);

    const selectedStore = () => root.querySelector('input[name="contact[Boutique]"]:checked');

    const slotsFor = (date) => {
      const store = selectedStore();
      if (!store) return null;
      const week = store.dataset.hours.split('|');
      const dayIndex = (date.getDay() + 6) % 7; // 0 = lundi
      const ranges = (week[dayIndex] || '')
        .split(',')
        .map((r) => r.trim())
        .filter(Boolean)
        .map((r) => r.split('-').map(toMinutes));
      if (!ranges.length) return null;
      const earliest = new Date(Date.now() + noticeHours * 3600 * 1000);
      const slots = [];
      for (const [open, close] of ranges) {
        for (let start = open; start + duration <= close; start += step) {
          const slotDate = new Date(date);
          slotDate.setHours(Math.floor(start / 60), start % 60, 0, 0);
          if (slotDate >= earliest) slots.push(start);
        }
      }
      return slots;
    };

    const refresh = () => {
      slotSelect.replaceChildren();
      dateError.hidden = true;
      dateInput.setCustomValidity('');
      if (!dateInput.value) {
        slotSelect.append(new Option(slotSelect.dataset.placeholder ?? '—', ''));
        return;
      }
      const [y, m, d] = dateInput.value.split('-').map(Number);
      const slots = slotsFor(new Date(y, m - 1, d));
      if (slots === null || slots.length === 0) {
        const message = slots === null ? texts.textClosed : texts.textNoSlot;
        dateError.textContent = message;
        dateError.hidden = false;
        dateInput.setCustomValidity(message);
        slotSelect.append(new Option('—', ''));
        return;
      }
      slotSelect.append(new Option(texts.textChooseSlot, ''));
      for (const start of slots) {
        const label = `${toHHMM(start)} – ${toHHMM(start + duration)}`;
        slotSelect.append(new Option(label, label));
      }
    };

    slotSelect.dataset.placeholder = slotSelect.options[0]?.textContent ?? '—';
    dateInput.addEventListener('change', refresh);
    root.querySelectorAll('input[name="contact[Boutique]"]').forEach((r) => r.addEventListener('change', refresh));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brands]').forEach((root) => {
    const frames = root.querySelectorAll('[data-brand-image]');
    if (!frames.length) return;
    const activate = (index) => {
      frames.forEach((frame) => frame.classList.toggle('brands__frame-item--active', frame.dataset.brandImage === index));
      root.querySelectorAll('[data-brand-trigger]').forEach((link) => link.toggleAttribute('data-active', link.dataset.brandTrigger === index));
    };
    root.querySelectorAll('[data-brand-trigger]').forEach((link) => {
      link.addEventListener('mouseenter', () => activate(link.dataset.brandTrigger));
      link.addEventListener('focus', () => activate(link.dataset.brandTrigger));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-stories"] && !Shopify.designMode) return;
  try {
    
  /* La marque du chapitre au milieu de l'écran s'allume dans l'index collant (et sa photo). */
  document.querySelectorAll('[data-brand-index]').forEach((root) => {
    const chapters = root.querySelectorAll('[data-brand-chapter]');
    if (!chapters.length || !('IntersectionObserver' in window)) return;
    const activate = (handle) => {
      root.querySelectorAll('[data-brand-nav], [data-brand-image]').forEach((el) => {
        const match = (el.dataset.brandNav || el.dataset.brandImage) === handle;
        el.toggleAttribute('data-active', match);
      });
    };
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) activate(entry.target.dataset.brandChapter);
        });
      },
      { rootMargin: '-45% 0px -50% 0px' },
    );
    chapters.forEach((chapter) => observer.observe(chapter));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-cart-drawer]');
    if (!dialog || !window.theme) return;
    const { Drawer, sections, cart, money } = window.theme;
    const drawer = new Drawer(dialog);
    const SECTION = 'cart-drawer';
    const itemTemplate = dialog.querySelector('[data-cart-template="item"]').content;
    let addedTimer = null;

    const content = () => dialog.querySelector('[data-cart-drawer-content]');

    const bind = () => {
      dialog.querySelectorAll('[data-drawer-close-link]').forEach((el) => el.addEventListener('click', () => drawer.close()));
      dialog.querySelectorAll('[data-cart-quantity]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const line = button.closest('[data-cart-item]').dataset.line;
          cart.change(line, button.dataset.cartQuantity).catch(() => {});
        });
      });
      dialog.querySelectorAll('[data-cart-quantity-input]').forEach((input) => {
        input.addEventListener('change', () => {
          const line = input.closest('[data-cart-item]').dataset.line;
          cart.change(line, input.value).catch(() => {});
        });
      });
    };

    /* Repli : le tiroir se redessine depuis le JSON du panier */
    const renderFromJson = (state) => {
      const root = content();
      const list = root.querySelector('[data-cart-items]');
      list.replaceChildren();
      state.items.forEach((item, index) => {
        const node = itemTemplate.cloneNode(true);
        const li = node.querySelector('[data-cart-item]');
        li.dataset.line = index + 1;
        const media = node.querySelector('.cart-item__media');
        media.href = item.url;
        const img = media.querySelector('img');
        if (item.image) {
          img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_240x$1$2');
        } else {
          img.remove();
        }
        const vendor = node.querySelector('[data-field="vendor"]');
        if (item.vendor) vendor.textContent = item.vendor;
        else vendor.remove();
        const title = node.querySelector('[data-field="title"]');
        title.href = item.url;
        title.textContent = item.product_title;
        const variant = node.querySelector('[data-field="variant"]');
        if (item.variant_title && item.variant_title !== 'Default Title') variant.textContent = item.variant_title.replace(/ \/ /g, ' · ');
        else variant.remove();
        node.querySelector('[data-cart-quantity-input]').value = item.quantity;
        const [minus, plus] = node.querySelectorAll('.quantity__button');
        minus.dataset.cartQuantity = item.quantity - 1;
        plus.dataset.cartQuantity = item.quantity + 1;
        node.querySelector('[data-field="price"]').textContent = money(item.final_line_price);
        node.querySelector('.cart-item__remove').href = `${window.Shopify?.routes?.root ?? '/'}cart/change?line=${index + 1}&quantity=0`;
        list.append(node);
      });
      root.querySelector('[data-cart-subtotal]').textContent = money(state.total_price);
      const label = root.querySelector('[data-cart-count-label]');
      const pattern = state.item_count === 1 ? root.dataset.textCountOne : root.dataset.textCountOther;
      label.textContent = `(${pattern.replace('%s', state.item_count)})`;
      root.querySelector('[data-cart-empty]').hidden = state.item_count > 0;
      root.querySelector('[data-cart-form]').hidden = state.item_count === 0;
    };

    const refresh = async (state, added) => {
      try {
        const html = await sections.fetch(SECTION, window.location.pathname);
        const fresh = sections.pick(html, '[data-cart-drawer-content]');
        if (!fresh) throw new Error('tiroir introuvable dans le rendu');
        content().replaceWith(fresh);
      } catch {
        renderFromJson(state);
      }
      bind();
      if (added) {
        const line = dialog.querySelector('[data-cart-added]');
        const variant = added.variant_title && added.variant_title !== 'Default Title' ? ` · ${added.variant_title}` : '';
        line.textContent = `${line.dataset.prefix ?? ''}${added.product_title}${variant}`;
        line.hidden = false;
        clearTimeout(addedTimer);
        addedTimer = setTimeout(() => (line.hidden = true), 4000);
      }
    };

    document.querySelectorAll('[data-cart-drawer-open]').forEach((button) => {
      button.addEventListener('click', () => drawer.open(button));
    });
    let errorTimer = null;
    document.addEventListener('theme:cart:error', (event) => {
      const line = dialog.querySelector('[data-cart-error]');
      if (!line) return;
      line.textContent = event.detail.message;
      line.hidden = false;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(() => (line.hidden = true), 6000);
      if (!drawer.isOpen && !document.querySelector('[data-product]')) drawer.open(document.activeElement);
    });
    document.addEventListener('theme:cart:updated', () => {
      const line = dialog.querySelector('[data-cart-error]');
      if (line) line.hidden = true;
    });
    document.addEventListener('theme:cart:updated', (event) => {
      refresh(event.detail.cart, event.detail.added).then(() => {
        if (event.detail.added) drawer.open(document.activeElement);
      });
    });
    bind();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const page = document.querySelector('[data-cart-page]');
    if (!page || !window.theme) return;
    const { cart } = window.theme;
    page.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-quantity]');
      if (!button) return;
      event.preventDefault();
      const line = button.closest('[data-cart-item]').dataset.line;
      cart.change(line, button.dataset.cartQuantity).then(() => window.location.reload()).catch(() => {});
    });
    page.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;
      const line = input.closest('[data-cart-item]').dataset.line;
      cart.change(line, input.value).then(() => window.location.reload()).catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charte-demo"]) return;
  try {
    
  (() => {
    const dialog = document.querySelector('[data-charte-drawer]');
    const opener = document.querySelector('[data-charte-drawer-open]');
    if (!dialog || !opener || !window.theme) return;
    const drawer = new window.theme.Drawer(dialog);
    opener.addEventListener('click', () => drawer.open(opener));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-collection]').forEach((root) => {
      if (!window.theme) return;
      const { sections, reveal, media } = window.theme;
      const sectionId = root.dataset.sectionId;
      const form = root.querySelector('[data-filters-form]');
      const aside = root.querySelector('[data-filters]');
      const backdrop = root.querySelector('[data-filters-backdrop]');
      const toggle = root.querySelector('[data-filters-open]');
      let controller = null;

      /* Panneau mobile */
      const openPanel = () => {
        aside.classList.add('filters--open');
        backdrop.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        aside.querySelector('input, button')?.focus({ preventScroll: true });
      };
      const closePanel = () => {
        aside?.classList.remove('filters--open');
        if (backdrop) backdrop.hidden = true;
        toggle?.setAttribute('aria-expanded', 'false');
      };
      toggle?.addEventListener('click', openPanel);
      backdrop?.addEventListener('click', closePanel);
      root.querySelector('[data-filters-close]')?.addEventListener('click', () => {
        closePanel();
        toggle?.focus();
      });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && aside?.classList.contains('filters--open')) {
          closePanel();
          toggle?.focus();
        }
      });

      /* Disposition : 5 / 4 / 3 par ligne (desktop), 2 / 1 (mobile). Défaut de l'éditeur, choix du
         visiteur retenu dans son navigateur (lecture et écriture protégées : navigation privée).
         Clé « v2 » depuis le 14/10/2026 : les anciens choix (2 par ligne) ne s'appliquent plus. */
      const views = root.querySelector('[data-collection-views]');
      const KEY = 'chrome:collection-columns-v2';
      const KEY_MOBILE = 'chrome:collection-columns-mobile';
      const read = (key) => {
        try {
          return window.localStorage.getItem(key);
        } catch {
          return null;
        }
      };
      const write = (key, value) => {
        try {
          window.localStorage.setItem(key, value);
        } catch {
          /* stockage indisponible : le choix vaut pour la page */
        }
      };
      let columns = read(KEY) || root.dataset.columnsDefault;
      let columnsMobile = read(KEY_MOBILE) || root.dataset.columnsMobileDefault;
      const applyView = () => {
        root.style.setProperty('--columns', columns);
        root.style.setProperty('--columns-mobile', columnsMobile);
        views?.querySelectorAll('[data-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.view === columns)));
        views
          ?.querySelectorAll('[data-view-mobile]')
          .forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.viewMobile === columnsMobile)));
      };
      views?.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.dataset.view) write(KEY, (columns = button.dataset.view));
        if (button.dataset.viewMobile) write(KEY_MOBILE, (columnsMobile = button.dataset.viewMobile));
        applyView();
      });
      applyView();

      /* Menu de tri maison (s'ouvre vers le bas) : pilote le <select> natif masqué. */
      const sortWrap = root.querySelector('.collection__sort');
      const sortMenu = root.querySelector('[data-sort-menu]');
      const sortSelect = root.querySelector('[data-collection-sort]');
      if (sortMenu && sortSelect) {
        const button = sortMenu.querySelector('[data-sort-button]');
        const list = sortMenu.querySelector('[data-sort-list]');
        const options = [...list.querySelectorAll('[role="option"]')];
        let active = Math.max(0, options.findIndex((o) => o.getAttribute('aria-selected') === 'true'));
        sortMenu.hidden = false;
        sortWrap.classList.add('collection__sort--enhanced');
        const highlight = (index) => {
          active = (index + options.length) % options.length;
          options.forEach((o, i) => o.toggleAttribute('data-active', i === active));
        };
        const open = () => {
          list.hidden = false;
          button.setAttribute('aria-expanded', 'true');
          highlight(active);
          list.focus({ preventScroll: true });
        };
        const close = (focusButton = false) => {
          list.hidden = true;
          button.setAttribute('aria-expanded', 'false');
          if (focusButton) button.focus();
        };
        const choose = (option) => {
          options.forEach((o) => o.setAttribute('aria-selected', String(o === option)));
          sortMenu.querySelector('[data-sort-current]').textContent = option.textContent;
          close(true);
          if (sortSelect.value === option.dataset.value) return;
          sortSelect.value = option.dataset.value;
          sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
        };
        button.addEventListener('click', () => (list.hidden ? open() : close()));
        options.forEach((option, index) => {
          option.addEventListener('click', () => choose(option));
          option.addEventListener('mousemove', () => highlight(index));
        });
        list.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') highlight(active + 1);
          else if (event.key === 'ArrowUp') highlight(active - 1);
          else if (event.key === 'Enter' || event.key === ' ') choose(options[active]);
          else if (event.key === 'Escape' || event.key === 'Tab') return close(event.key === 'Escape');
          else return;
          event.preventDefault();
        });
        document.addEventListener('click', (event) => {
          if (!list.hidden && !sortMenu.contains(event.target)) close();
        });
      }

      /* Rendu sans rechargement */
      const results = () => root.querySelector('[data-collection-results]');
      const load = async (url, { append = false } = {}) => {
        controller?.abort();
        controller = new AbortController();
        results().setAttribute('aria-busy', 'true');
        try {
          const html = await sections.fetch(sectionId, url, controller.signal);
          const fresh = sections.pick(html, '[data-collection]');
          if (!fresh) throw new Error('section introuvable');
          if (append) {
            const grid = root.querySelector('[data-collection-grid]');
            fresh.querySelectorAll('[data-collection-grid] > li').forEach((li) => grid.append(li));
            root.querySelector('[data-collection-pagination]').replaceWith(fresh.querySelector('[data-collection-pagination]'));
          } else {
            results().replaceWith(fresh.querySelector('[data-collection-results]'));
            root.querySelector('[data-collection-count]').textContent = fresh.querySelector('[data-collection-count]').textContent;
            const freshFilters = fresh.querySelector('[data-collection-filters]');
            const currentFilters = root.querySelector('[data-collection-filters]');
            if (freshFilters && currentFilters) currentFilters.replaceWith(freshFilters);
            const freshCount = fresh.querySelector('[data-filters-active-count]');
            const currentCount = root.querySelector('[data-filters-active-count]');
            if (currentCount) currentCount.remove();
            if (freshCount) toggle?.append(freshCount);
          }
          window.history.replaceState({}, '', url);
          reveal.observe(root);
          if (!append && !media.desktop.matches) root.scrollIntoView({ block: 'start', behavior: 'auto' });
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.assign(url); // repli : la page classique
        } finally {
          results()?.removeAttribute('aria-busy');
        }
      };

      const urlFromForm = () => {
        const params = new URLSearchParams(new FormData(form));
        const sort = root.querySelector('[data-collection-sort]');
        if (sort?.value) params.set('sort_by', sort.value);
        for (const [key, value] of [...params]) if (value === '') params.delete(key);
        return `${window.location.pathname}?${params.toString()}`;
      };

      form?.addEventListener('change', (event) => {
        if (event.target.type === 'number') return; // le prix se valide au bouton Appliquer
        load(urlFromForm());
      });
      form?.addEventListener('submit', (event) => {
        event.preventDefault();
        closePanel();
        load(urlFromForm());
      });
      root.querySelector('[data-collection-sort]')?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', root.querySelector('[data-collection-sort]').value);
        url.searchParams.delete('page');
        load(url.pathname + url.search);
      });
      root.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-filter-remove], [data-filters-clear]');
        if (remove) {
          event.preventDefault();
          closePanel();
          load(remove.getAttribute('href'));
          return;
        }
        const more = event.target.closest('[data-load-more]');
        if (more) {
          more.disabled = true;
          load(more.dataset.url, { append: true });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    if (!header || !window.theme) return;
    const { Drawer, media } = window.theme;

    /* En-tête opaque dès que la sentinelle du hero est sortie */
    const sentinel = document.querySelector('.main-content > .shopify-section:first-child [data-header-sentinel]');
    if (sentinel) {
      new IntersectionObserver(([entry]) => header.classList.toggle('header--solid', !entry.isIntersecting), {
        rootMargin: `-${header.offsetHeight}px 0px 0px 0px`,
      }).observe(sentinel);
    }

    /* Compteur du panier */
    document.addEventListener('theme:cart:updated', (event) => {
      const count = event.detail.cart.item_count;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    });

    /* Menu mobile : un niveau à la fois */
    const dialog = document.querySelector('[data-mobile-menu]');
    const opener = header.querySelector('[data-mobile-menu-open]');
    if (dialog && opener) {
      const drawer = new Drawer(dialog);
      const back = dialog.querySelector('[data-mobile-menu-back]');
      const title = dialog.querySelector('[data-mobile-menu-title]');
      const body = dialog.querySelector('.mobile-menu__body');
      const stack = [];

      const show = (id, direction) => {
        const current = dialog.querySelector('.mobile-menu__panel:not([hidden])');
        const next = dialog.querySelector(`[data-panel="${id}"]`);
        if (!next || next === current) return;
        current?.setAttribute('hidden', '');
        next.removeAttribute('hidden');
        if (direction === 'forward' && !media.reducedMotion.matches) {
          next.classList.add('mobile-menu__panel--enter');
          requestAnimationFrame(() => requestAnimationFrame(() => next.classList.remove('mobile-menu__panel--enter')));
        }
        body.scrollTop = 0;
        title.textContent = next.dataset.title;
        back.hidden = stack.length === 0;
        next.querySelector('a, button')?.focus({ preventScroll: true });
      };

      opener.addEventListener('click', () => {
        drawer.open(opener);
        opener.setAttribute('aria-expanded', 'true');
      });
      dialog.addEventListener('drawer:close', () => {
        opener.setAttribute('aria-expanded', 'false');
        stack.length = 0;
        show('root', 'back');
      });
      dialog.querySelectorAll('[data-panel-open]').forEach((button) => {
        button.addEventListener('click', () => {
          stack.push(button.closest('[data-panel]').dataset.panel);
          show(button.dataset.panelOpen, 'forward');
        });
      });
      back.addEventListener('click', () => show(stack.pop() ?? 'root', 'back'));
    }

    /* Méga menu : survol avec intention, clavier et tactile.
       Survol : ouverture après 80 ms (un simple passage de souris n'ouvre rien), fermeture après
       300 ms hors de l'en-tête (on peut glisser vers le panneau ou déraper sans tout perdre). D'une
       rubrique ouverte à une autre, l'échange est immédiat. */
    const items = header.querySelectorAll('[data-mega-item]');
    const closeAll = (except) => {
      items.forEach((item) => {
        if (item === except) return;
        item.classList.remove('mega-menu__item--open');
        item.querySelector('.mega-menu__link')?.setAttribute('aria-expanded', 'false');
      });
    };
    items.forEach((item) => {
      const link = item.querySelector('.mega-menu__link');
      const panel = item.querySelector('[data-mega-panel]');
      if (!panel) return;
      link.addEventListener('click', (event) => {
        // Sans survol possible (tactile), le premier tap ouvre le panneau, le second suit le lien.
        if (!media.hover.matches && !item.classList.contains('mega-menu__item--open')) {
          event.preventDefault();
          closeAll(item);
          item.classList.add('mega-menu__item--open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
      link.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' || (event.key === 'Enter' && !item.classList.contains('mega-menu__item--open'))) {
          event.preventDefault();
          closeAll(item);
          item.classList.add('mega-menu__item--open');
          link.setAttribute('aria-expanded', 'true');
          panel.querySelector('a')?.focus();
        }
      });
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeAll();
          link.focus();
        }
      });
      // Tabuler jusqu'à un lien du panneau l'ouvre ; en sortir le ferme.
      panel.addEventListener('focusin', () => {
        closeAll(item);
        item.classList.add('mega-menu__item--open');
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) closeAll();
      });
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeAll();
    });

    const menu = header.querySelector('.mega-menu');
    let openTimer;
    let closeTimer;
    const isOpen = () => [...items].some((i) => i.classList.contains('mega-menu__item--open'));
    const open = (item) => {
      const switching = isOpen();
      menu?.classList.toggle('mega-menu--switching', switching);
      closeAll(item);
      item.classList.add('mega-menu__item--open');
      item.querySelector('.mega-menu__link')?.setAttribute('aria-expanded', 'true');
      if (switching) requestAnimationFrame(() => menu?.classList.remove('mega-menu--switching'));
    };
    const scheduleClose = (delay) => {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => closeAll(), delay);
    };
    items.forEach((item) => {
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        if (!item.querySelector('[data-mega-panel]')) {
          // Rubrique sans panneau : on ferme, mais sans précipitation.
          if (isOpen()) scheduleClose(200);
          return;
        }
        if (item.classList.contains('mega-menu__item--open')) return;
        openTimer = setTimeout(() => open(item), isOpen() ? 0 : 80);
      });
    });
    header.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    header.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'mouse') scheduleClose(300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* Vidéo du hero : lecture lancée par le script (jamais si le mouvement est réduit), arrêt hors
     écran pour ne rien consommer inutilement, bouton lecture / pause. */
  (() => {
    const init = (video) => {
      if (video.dataset.ready) return;
      video.dataset.ready = '1';
      const toggle = video.closest('.hero')?.querySelector('[data-hero-video-toggle]');
      let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let visible = true;

      const sync = () => {
        if (!paused && visible) {
          video.preload = 'auto';
          video.play().then(() => video.classList.add('is-playing')).catch(() => {});
        } else {
          video.pause();
        }
        if (toggle) {
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
        }
      };

      if (toggle) {
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          paused = !paused;
          sync();
        });
      }
      new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        sync();
      }).observe(video);
    };

    // La vidéo démarre une fois la page chargée : l'image d'attente (LCP), les styles et les scripts
    // passent d'abord. Rien si le visiteur a demandé à économiser ses données.
    const scan = () => {
      if (navigator.connection?.saveData) return;
      document.querySelectorAll('[data-hero-video]').forEach(init);
    };
    if (document.readyState === 'complete') scan();
    else window.addEventListener('load', scan, { once: true });
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  /* Lookbook éditorial, placement sans trou ni chevauchement. Après les deux premiers looks, la
     grille avance par segments qui commencent et finissent à niveau :
     - pleine largeur : le look seul sur toute la ligne ;
     - bande : un look sur 2 colonnes (à droite puis à gauche, en alternance) et, à côté, les looks
       suivants empilés jusqu'à sa hauteur ;
     - colonnes : une suite de looks sur 1 colonne, chacun dans la colonne la plus courte (s'ils
       sont moins nombreux que les colonnes, ils s'élargissent pour remplir la ligne).
     Un segment se referme en allongeant la dernière photo des colonnes les plus courtes (photo
     recadrée), donc la grille finit toujours droite. Sur téléphone, « 2 colonnes » = pleine
     largeur. Sans script, la répartition du CSS reste valable (sans les largeurs). */
  (() => {
    const wide = window.matchMedia('(min-width: 750px)');
    const LEAD_ROWS = 63;

    const layout = (grid) => {
      const looks = [...grid.querySelectorAll(':scope > * > .look')].filter((look) => look.getClientRects().length);
      const cols = wide.matches ? 3 : 2;
      const unit = cols === 3 ? 2 : 1; // pistes de grille par colonne
      const info = looks.map((look) => ({
        look,
        span: Math.min(cols, parseInt(look.getAttribute(wide.matches ? 'data-span-3' : 'data-span-2'), 10) || 1),
        rows: parseInt(getComputedStyle(look).getPropertyValue(wide.matches ? '--look-rows-3' : '--look-rows-2'), 10) || 44,
      }));
      const place = (item, col, span, top, rows) => {
        Object.assign(item, { col, span, top, rows });
        item.look.style.gridColumn = `${col * unit + 1} / span ${span * unit}`;
        item.look.style.gridRow = `${top + 1} / span ${rows}`;
      };
      const grow = (item, bottom) => place(item, item.col, item.span, item.top, bottom - item.top);

      looks.forEach((look) => {
        look.style.gridColumn = '';
        look.style.gridRow = '';
      });

      let top = LEAD_ROWS;
      let bands = 0;
      let i = 2;
      while (i < info.length) {
        const item = info[i];

        if (item.span === cols) {
          place(item, 0, cols, top, item.rows);
          top += item.rows;
          i += 1;
        } else if (item.span > 1) {
          // Bande : le look large, et la colonne d'à côté remplie jusqu'à sa hauteur.
          const side = bands % 2 ? 0 : cols - 1;
          const stack = [];
          let height = 0;
          i += 1;
          while (i < info.length && info[i].span === 1 && height < item.rows - 8) {
            stack.push(info[i]);
            height += info[i].rows;
            i += 1;
          }
          if (!stack.length) {
            place(item, 0, cols, top, Math.round((item.rows * cols) / item.span));
            top += item.rows;
            continue;
          }
          bands += 1;
          place(item, side === 0 ? 1 : 0, item.span, top, item.rows);
          let y = top;
          stack.forEach((s) => {
            place(s, side, 1, y, s.rows);
            y += s.rows;
          });
          const bottom = Math.max(y, top + item.rows);
          grow(item, bottom);
          grow(stack[stack.length - 1], bottom);
          top = bottom;
        } else {
          // Colonnes : les looks sur 1 colonne qui se suivent.
          const run = [];
          while (i < info.length && info[i].span === 1) {
            run.push(info[i]);
            i += 1;
          }
          const lasts = new Array(cols).fill(null);
          const heights = new Array(cols).fill(top);
          if (run.length < cols) {
            let col = 0;
            run.forEach((r, n) => {
              const span = n === 0 ? cols - run.length + 1 : 1;
              const rows = r.rows * span; // plus large, donc plus haut, au même format
              place(r, col, span, top, rows);
              for (let c = col; c < col + span; c += 1) {
                heights[c] = top + rows;
                lasts[c] = r;
              }
              col += span;
            });
          } else {
            run.forEach((r) => {
              const col = heights.indexOf(Math.min(...heights));
              place(r, col, 1, heights[col], r.rows);
              heights[col] += r.rows;
              lasts[col] = r;
            });
          }
          const bottom = Math.max(...heights);
          new Set(lasts).forEach((r) => grow(r, bottom));
          top = bottom;
        }
      }
    };

    const run = () => document.querySelectorAll('.lookbook--editorial .lookbook__grid').forEach(layout);
    run();
    wide.addEventListener('change', run);
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  // Les tableaux saisis dans l'admin n'ont pas d'enveloppe : on leur en donne une qui défile.
  document.querySelectorAll('[data-page-content] table').forEach((table) => {
    if (table.parentElement.classList.contains('table-scroll')) return;
    const wrap = document.createElement('div');
    wrap.className = 'table-scroll';
    table.replaceWith(wrap);
    wrap.append(table);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product]');
    if (!root || !window.theme) return;
    const { Drawer, money, media } = window.theme;
    const texts = root.dataset;

    /* Guide des tailles */
    const sizeGuide = document.querySelector('[data-size-guide]');
    if (sizeGuide) {
      const drawer = new Drawer(sizeGuide);
      const body = sizeGuide.querySelector('[data-size-guide-body]');
      let loaded = Boolean(body.querySelector('.rte'));
      const load = async () => {
        if (loaded) return;
        loaded = true;
        try {
          const html = await fetch(sizeGuide.dataset.url).then((r) => (r.ok ? r.text() : Promise.reject(r.status)));
          const content = new DOMParser().parseFromString(html, 'text/html').querySelector('.size-guide');
          if (!content) throw new Error('guide introuvable');
          content.querySelectorAll('[data-reveal]').forEach((el) => el.setAttribute('data-reveal', 'done'));
          content.classList.remove('section', 'section--tight');
          body.replaceChildren(content);
        } catch {
          const link = Object.assign(document.createElement('a'), { className: 'link', href: sizeGuide.dataset.url, textContent: sizeGuide.getAttribute('aria-label') });
          body.replaceChildren(link);
        }
      };
      root.querySelectorAll('[data-size-guide-open]').forEach((b) =>
        b.addEventListener('click', () => {
          drawer.open(b);
          load();
        }),
      );
    }

    /* Galerie : points / compteur sur mobile, zoom */
    const gallery = root.querySelector('[data-gallery]');
    const track = gallery?.querySelector('[data-gallery-track]');
    const items = track ? [...track.querySelectorAll('[data-gallery-item]')] : [];
    const current = gallery?.querySelector('[data-gallery-current]');
    if (track && items.length > 1) {
      const sync = () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        gallery.querySelectorAll('.gallery__dot').forEach((dot, i) => dot.classList.toggle('gallery__dot--active', i === index));
        if (current) current.textContent = index + 1;
      };
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    }
    const zoomDialog = document.querySelector('[data-gallery-zoom-dialog]');
    if (zoomDialog) {
      const image = zoomDialog.querySelector('[data-gallery-zoom-image]');
      root.querySelectorAll('[data-gallery-zoom]').forEach((button) => {
        button.addEventListener('click', () => {
          image.src = button.dataset.galleryZoom;
          image.alt = button.querySelector('img')?.alt ?? '';
          zoomDialog.showModal();
        });
      });
      zoomDialog.addEventListener('click', () => zoomDialog.close());
      zoomDialog.querySelector('[data-gallery-zoom-close]').addEventListener('click', () => zoomDialog.close());
    }
    /*
     * Coloris → galerie. Si au moins une photo est attribuée à un coloris (data-color), on ne montre
     * que les photos du coloris choisi + les photos communes, puis on remonte au début de la galerie.
     * Si aucune photo n'est attribuée, on ne filtre rien (mieux vaut tout montrer qu'un mauvais coloris).
     */
    const hasColorMedia = items.some((el) => el.dataset.color);
    const behavior = () => (media.reducedMotion.matches ? 'auto' : 'smooth');
    const rebuildDots = () => {
      const visible = items.filter((el) => !el.hidden);
      const list = gallery?.querySelector('[data-gallery-dots]');
      if (list) list.replaceChildren(...visible.map((_, i) => Object.assign(document.createElement('li'), { className: `gallery__dot${i === 0 ? ' gallery__dot--active' : ''}` })));
      const total = gallery?.querySelector('[data-gallery-total]');
      if (total) total.textContent = visible.length;
      if (current) current.textContent = 1;
    };
    const showColor = (color) => {
      if (!hasColorMedia || !track) return;
      const matching = items.filter((el) => el.dataset.color === color);
      if (!matching.length) {
        // Coloris sans photo (ex. pantalon « Mathis » : Beige et Vert sans visuel) : tout montrer,
        // plutôt que laisser affichées les photos du coloris précédent.
        items.forEach((el) => {
          el.hidden = false;
          el.style.order = '';
        });
        rebuildDots();
        return;
      }
      items.forEach((el) => {
        el.hidden = Boolean(el.dataset.color) && el.dataset.color !== color;
        // Les photos du coloris passent devant les photos communes (CSS order, sans toucher au DOM).
        el.style.order = el.dataset.color === color ? '-1' : '';
      });
      rebuildDots();
      if (media.desktop.matches) {
        const top = gallery.getBoundingClientRect().top;
        if (top < 0) gallery.scrollIntoView({ block: 'start', behavior: behavior() });
      } else {
        track.scrollTo({ left: 0, behavior: behavior() });
        // Galerie sortie de l'écran (on a défilé jusqu'aux options) : on la ramène, juste sous l'en-tête.
        if (gallery.getBoundingClientRect().bottom < window.innerHeight * 0.25) {
          gallery.scrollIntoView({ block: 'start', behavior: behavior() });
        }
      }
    };
    const showMedia = (mediaId) => {
      const item = items.find((el) => el.dataset.mediaId === String(mediaId) && !el.hidden);
      if (!item) return;
      if (media.desktop.matches) {
        item.scrollIntoView({ block: 'start', behavior: behavior() });
      } else {
        track.scrollTo({ left: item.offsetLeft, behavior: behavior() });
      }
    };

    /* Quantité */
    const quantity = root.querySelector('[data-quantity] input');
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value) - 1);
    });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Number(quantity.value) + 1;
    });

    /* Variants */
    const variants = JSON.parse(root.querySelector('[data-variants-json]')?.textContent || '[]');
    const select = root.querySelector('[data-variant-select]');
    const submit = root.querySelector('[data-add-to-cart]');
    const submitText = root.querySelector('[data-add-to-cart-text]');
    const price = root.querySelector('[data-product-price]');
    const buyBar = root.querySelector('[data-buy-bar]');
    const buyBarPrice = root.querySelector('[data-buy-bar-price]');
    const buyBarSubmit = root.querySelector('[data-buy-bar-submit]');
    const fieldsets = [...root.querySelectorAll('[data-option-fieldset]')].sort(
      (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition),
    );

    const selectedOptions = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value ?? null);
    let lastColor = null;

    const renderPrice = (variant) => {
      if (!price) return;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      price.innerHTML = onSale
        ? `<span class="price__sale">${money(variant.price)}</span> <s class="price__compare">${money(variant.compare_at_price)}</s>`
        : `<span class="price__regular">${money(variant.price)}</span>`;
      price.classList.toggle('price--on-sale', Boolean(onSale));
      if (buyBarPrice) buyBarPrice.textContent = money(variant.price);
    };

    const markUnavailableValues = (selected) => {
      // Une valeur est « indisponible » si aucun variant disponible ne la combine avec les autres choix.
      fieldsets.forEach((fs, index) => {
        fs.querySelectorAll('input[data-option-input]').forEach((input) => {
          const candidate = [...selected];
          candidate[index] = input.value;
          const possible = variants.some(
            (v) => v.available && v.options.every((opt, i) => candidate[i] === null || opt === candidate[i]),
          );
          input.nextElementSibling?.classList.toggle('product-form__value--unavailable', !possible);
        });
      });
    };

    /* Shopify ne donne la disponibilité en boutique que pour le variant de l'URL :
       on recharge la ligne de ce seul bloc à chaque changement de taille. */
    const availability = root.querySelector('[data-availability]');
    const sectionId = root.closest('.shopify-section')?.id.replace('shopify-section-', '');
    let availabilityRequest = 0;
    const refreshAvailability = (variantId) => {
      if (!availability || !sectionId) return;
      const request = ++availabilityRequest;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);
      fetch(url)
        .then((response) => (response.ok ? response.text() : Promise.reject()))
        .then((html) => {
          if (request !== availabilityRequest) return;
          const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-availability]');
          if (next) availability.innerHTML = next.innerHTML;
        })
        .catch(() => {});
    };

    const update = () => {
      const selected = selectedOptions();
      fieldsets.forEach((fs, i) => {
        const label = root.querySelector(`[data-option-value="${fs.dataset.optionPosition}"]`);
        // Libellé affiché : le nom commercial du coloris porté par l'input (data-label), sinon la valeur technique.
        const checked = fs.querySelector('input:checked');
        if (label) label.textContent = checked?.dataset.label || selected[i] || '';
      });
      markUnavailableValues(selected);
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) {
        submit.disabled = true;
        submitText.textContent = texts.textUnavailable;
        if (buyBarSubmit) buyBarSubmit.disabled = true;
        return;
      }
      select.value = variant.id;
      submit.disabled = !variant.available;
      submitText.textContent = variant.available ? texts.textAdd : texts.textSoldOut;
      if (buyBarSubmit) buyBarSubmit.disabled = !variant.available;
      renderPrice(variant);
      refreshAvailability(variant.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      const colorFieldset = root.querySelector('.swatches--product')?.closest('[data-option-fieldset]');
      const colorIndex = colorFieldset ? fieldsets.indexOf(colorFieldset) : -1;
      if (colorIndex >= 0 && hasColorMedia) {
        if (lastColor !== selected[colorIndex]) showColor(selected[colorIndex]);
        lastColor = selected[colorIndex];
      } else if (variant.featured_media) {
        showMedia(variant.featured_media.id);
      }
    };

    if (variants.length && select && fieldsets.length) {
      root.querySelectorAll('input[data-option-input]').forEach((input) => input.addEventListener('change', update));
      markUnavailableValues(selectedOptions());
      const colorFieldset = root.querySelector('.swatches--product')?.closest('[data-option-fieldset]');
      const colorIndex = colorFieldset ? fieldsets.indexOf(colorFieldset) : -1;
      if (colorIndex >= 0) {
        lastColor = selectedOptions()[colorIndex];
        if (hasColorMedia) {
          const color = lastColor;
          const known = items.some((i) => i.dataset.color === color);
          items.forEach((el) => {
            el.hidden = known && Boolean(el.dataset.color) && el.dataset.color !== color;
            el.style.order = known && el.dataset.color === color ? '-1' : '';
          });
          rebuildDots();
        }
      }
    }

    /* Erreurs d'ajout (stock insuffisant…) affichées sous le bouton, en français (theme.js cart) */
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const error = root.querySelector('[data-form-error]');
    document.addEventListener('theme:cart:error', (event) => {
      if (!error) return;
      error.textContent = event.detail.message;
      error.hidden = false;
    });
    form?.addEventListener('submit', () => {
      if (error) error.hidden = true;
    });

    /* Barre collante : visible quand le bouton principal est hors écran (mobile) */
    if (buyBar && submit) {
      buyBar.hidden = false;
      new IntersectionObserver(([entry]) => buyBar.classList.toggle('buy-bar--visible', !entry.isIntersecting), {
        threshold: 0,
      }).observe(submit);
      buyBarSubmit?.addEventListener('click', () => form?.requestSubmit());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-related-products]').forEach(async (container) => {
    if (container.dataset.loaded) return;
    container.dataset.loaded = 'true';
    try {
      const response = await fetch(container.dataset.url);
      if (!response.ok) return;
      const html = await response.text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related-grid]');
      if (!fresh) return; // pas de recommandations : la grille serveur reste
      container.querySelector('[data-related-grid]')?.replaceWith(fresh);
      window.theme?.reveal.observe(container);
    } catch {
      /* la grille serveur reste */
    }
  });

  } catch(e) { console.error(e); }
})();
})();
